import React from 'react';
import { Box } from '@mui/material';
import TopStepAccountPage from './TopStepAccountPage';
import ProfileCDecisionLog from '../components/ProfileCDecisionLog';

const TopStep50KChallengePage: React.FC = () => (
  <Box>
    <TopStepAccountPage
      accountLabel="TopStep 50K Combine — Profile C (Reset)"
      accountMatcher={(accts) => accts.find(a => a.accountName.includes('93734713'))}
      challengeParams={{ target: 3000, hardMax: 2000, internalStop: 1700, dailyCap: 1000, accountSize: 50000 }}
      chipLabel="50K COMBINE"
      chipColor="#CE93D8"
    />
    <ProfileCDecisionLog />
  </Box>
);

export default TopStep50KChallengePage;
